/**
 * 新版的元素位置修正
 * 2018-03-13
 * Bai.Zhiming
 * @attribute floatHeight（可选）:当遇到浮动时，元素高度为0，而子元素不为0，造成偏差，该参数为偏差额，以便修正。
 */
"use strict";
angular.module("trsScrollFixNewModule", []).
directive("trsScrollFixNew", ["$timeout", function($timeout) {
    return {
        replace: false,
        restrict: "A",
        scope: false,
        link: function(scope, $elem, $attrs) {
            var $fixRelativeElement, $fixBoxElement, fixTop, floatHeight,
                findTimes = 0;
            init();
            /**
             * [init description] 初始化
             * @return {[type]} [description]
             */
            function init() {
                findRelativeElement(function() {
                    fixTop = isNaN($attrs["fixTop"]) ? 0 : Number($attrs["fixTop"]);
                    floatHeight = isNaN($attrs["floatHeight"]) ? 0 : Number($attrs["floatHeight"]);
                    $fixBoxElement = $($attrs["fixBoxElement"]);
                    bindScroll();
                });
            }
            /**
             * [findRelativeElement description] 获取参照元素
             * @return {[type]} [description]
             */
            function findRelativeElement(success) {
                $fixRelativeElement = $($attrs["fixRelativeElement"]);
                if ($fixRelativeElement.length > 0) {
                    success();
                } else {
                    $timeout(function() {
                        if (findTimes > 4) return;
                        findRelativeElement(success);
                        findTimes++;
                    }, 1000);
                }
            }
            /**
             * [bindScroll description] 绑定滚动事件
             * @return {[type]} [description]
             */
            function bindScroll() {
                window.addEventListener("scroll", myScroll);
                /**
                 * [myScroll description] 滚动事件
                 * @return {[type]} [description]
                 */
                function myScroll() {    
                    var htmlScrollTop = $("body")[0].scrollTop || $("html")[0].scrollTop; //html的滚动距离
                    var referenceRealTop = $fixRelativeElement.offset().top - htmlScrollTop; //参照物的真实上边距
                    var referenceHeight = $fixRelativeElement[0].offsetHeight; //参照物的高度
                    var referenceRelativeTop = $fixRelativeElement.offset().top; //参照物的数值上边距
                    var referenceShowHeight = referenceHeight + referenceRelativeTop; //参照物的页面展示高度
                    var mainTop = htmlScrollTop + 60; //referenceRelativeTop; //滚动修复主区域的真实顶部高度
                    var mainHeight = $elem[0].offsetHeight + floatHeight; //滚动修复主区域的高度
                    var mainShowHeight = mainHeight + mainTop; //滚动修复主区域的展示高度
                    if (htmlScrollTop === 0) {
                        $elem.css({
                            position: "relative",
                            zIndex: "initial",
                            top: "initial",
                            overflow: "initial"
                        });
                        return;
                    }
                    if (mainShowHeight > referenceShowHeight) {
                        $elem.css({
                            position: "relative",
                            overflow: "initial",
                            zIndex: 999
                        });
                        $elem.offset({ top: referenceShowHeight - mainHeight });
                        return;
                    }
                    if (referenceRealTop < referenceRelativeTop) {
                        $elem.css({
                            position: "relative",
                            zIndex: 999,
                            overflow: "initial"
                        });
                        $elem.offset({ top: mainTop });
                    } else {
                        $elem.css({
                            position: "relative",
                            zIndex: "initial",
                            top: "initial",
                            overflow: "initial"
                        });
                    }
                }
            }
        }
    };
}]);